module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm_title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("AFSA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Armed Forces Security Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("AGI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Auxiliary Vessel, Intelligence Gatherer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("AI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Air Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("ASA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Army Security Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("BEF")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Expeditionary Force")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("BRUSA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Britain – United States of America Security Pact")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("CBME")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Combined Bureau Middle East")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("CIA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("American Central Intelligence Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("CID")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Committee of Imperial Defence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("CSDIC")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Combined Services Detailed Interrogation Centre")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("CSE")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Canadian Communications Security Establishment")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("DF")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Direction-finding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("DMI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Director of Military Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("DNI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Director of Naval Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("DSD")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Australian Defence Signals Directorate")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("DWS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Diplomatic Wireless Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("FBI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("American Federal Bureau of Investigation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("FECB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Far East Combined Bureau")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("GC&CS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Government Code and Cypher School")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("GCHQ")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Government Communications Headquarters")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("GPO")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("General Post Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("HDU")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Home Defence Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("KGB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Soviet Committee for State Security")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("MI1")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Directorate of Military Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("MI5")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Security Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("MI6")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Secret Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("MI8")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Radio Security Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("MI9")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("British Escape and Evasion Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("NATO")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("North Atlantic Treaty Organisation")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("NID")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Naval Intelligence Division")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("NKVD")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Soviet Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("NSA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("American National Security Agency")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("NZCSB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("New Zealand Communications Security Bureau")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("OSS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Office of Strategic Services")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("PCO")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Passport Control Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("RSGB")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Radio Society of Great Britain")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("RSS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Radio Security Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SCU")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Communications Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SD")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Nazi Security Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SIS")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("American Signal Intelligence Service")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SLO")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Security Liaison Officer")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SLU")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Liaison Unit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SOE")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Operations Executive")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("SWG")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Special Wireless Group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("UKUSA")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("United Kingdom – United States of America Security Agreement")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("VI")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Voluntary Interceptor")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "tab1"
  }, [_vm._v("Y")]), _vm._v(" "), _c('td', {
    staticClass: "tab2"
  }, [_vm._v("Wireless Interception")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8437bbe4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Abbreviations.vue
// module id = 72
// module chunks = 0